<template>
	<div>
		<egranty-section-divider
			text="Grupy docelowe"
			icon="people"
		></egranty-section-divider>

		<br style="margin-top: 20px">
		<v-layout row>
			<v-flex xs5>
				<v-expand-transition aria-label="label for group">
					<v-select
						style="padding-left: 20px; padding-right: 20px; max-width: 500px"
						:disabled="true"
						v-model="data.selected"
						:items="options"
						item-text="name"
						item-value="id"
						multiple
						label="Grupy docelowe"
						aria-label="beneficiaries"
						for="agency-choose-beneficiaries-point-groups-target"
						id="agency-choose-beneficiaries-point-groups-target"
						@input="sync"
					></v-select>
				</v-expand-transition>
			</v-flex>
			<v-flex xs2>
				<egranty-switch
					aria-label="another beneficiary enabled"
					title='Inna grupa docelowa'
					v-model="data.otherBeneficiaryEnabled"
					@input="hasOtherBeneficiaryChanged"
				></egranty-switch>
			</v-flex>
			<v-flex xs4>
				<v-expand-transition>
					<egranty-text-input-field
						class="other-group-target-card"
						style="margin-left: 20px"
						:disabled="true"
						v-show="data.otherBeneficiaryEnabled"
						label="Nazwa innej grupy docelowej"
						for="agency-choose-beneficiaries-name-other-groups-target"
						id="agency-choose-beneficiaries-name-other-groups-target"
						textarea
					>
					</egranty-text-input-field>
				</v-expand-transition>
			</v-flex>
		</v-layout>
		
	</div>
</template>

<script>
	import EgrantySwitch from "../../../../genericComponents/EgrantySwitch";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	

	export default {
		name: "AgencyChooseBeneficiariesEmpty",
		components: {EgrantySectionDivider, EgrantyTextInputField, EgrantySwitch},
		methods: {
			getContestId() {
				return this.$route.params.contestId || this.$route.params.id;
			},

			sync() {
				// Nie zapisujemy, to jest tylko podgląd
				this.$emit("input", this.data);
				this.error = "";
			},

			hasOtherBeneficiaryChanged(newHasOtherBeneficiary) {
				// Nie zapisujemy, to jest tylko podgląd
				if (newHasOtherBeneficiary) {
					this.data.otherBeneficiary = null;
				}
				this.sync();
			},

		
		},

		

		data() {
			return {
				
				data: {
					selected: [],
					otherBeneficiary: "",
					otherBeneficiaryEnabled: false,
				},
				options: [],

			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.data.otherBeneficiary = val.otherBeneficiary;
					this.data.otherBeneficiaryEnabled = val.otherBeneficiaryEnabled;
					this.data.selected = val.selected;
				},
			},
		},

		props: {
			readonly: {default: false},
			value: {},
		},
	};
</script>

<style>
@media print {
	.other-group-target-card {
		margin: 0 10px 10px;
	}
	.other-group-target-card .div-for-print {
		border: 1px solid grey;
		color: rgba(0,0,0,0.87);
	}
	.other-group-target-card p {
		margin-bottom: 8px;
	}
	.agency-choose-actions {
		border: 1px solid grey;
		margin-bottom: 10px;
	}
	.agency-actions-costs .blue.white--text {
		border: 1px solid grey !important;
	}
	.agency-actions-costs i {
		display: none;
	}
}
</style>